(function(){

  class ProductFeedFilter extends HTMLElement {
    constructor() {
      super();
      this.products = this.querySelectorAll('.product-feed__collection [data-slide-benefits]');
      this.filters = this.querySelectorAll('.product-feed__filters li');
      this.currentFilter = '';
      this.slider = this.initFeedSlider();
    }

    connectedCallback() {
      console.log(this.slider );
      this.bindEvents();
    }

    initFeedSlider() {
      if ( !this.querySelector('.feed-slider') ) return;

      const options = {
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 30
      }
  
      
      if ( document.body.clientWidth > 767 ) {
        options.centeredSlides = false;
      }
      if ( document.body.clientWidth > 990 ) {
        options.centeredSlides = false;
      }
  
  
      return new Swiper('.feed-slider', options);
    }

    bindEvents() {
      this.filters.forEach(filter =>{
        filter.addEventListener('click', e => {
          const benefit = e.target.textContent.toLowerCase();

         
          
  
          if ( !e.target.classList.contains('active') ) {
            this.removeClasses(this.filters, 'active');
            e.target.classList.add('active');
            $('.product-feed__collection').animate({ opacity: 0 }, 500, () => {
              this.productFilter(benefit);
            });
          } else {
            $('.product-feed__collection').animate({ opacity: 0 }, 500, () => {
              this.resetFilter();
            });
            e.target.classList.remove('active');
          }
        });
      })
    }

    productFilter(benefit) {
      $('.product-feed__collection').animate({ opacity: 1 }, 500);
      if (benefit === this.currentFilter) {
        this.removeClasses(this.products, 'to-hide');
        this.currentFilter = '';
      } else {
        this.products.forEach(product => {
          const benefits = product.dataset.slideBenefits;
          if ( benefits.indexOf(benefit) === -1 ) {
            product.classList.add('to-hide');
          } else {
            if (product.classList.contains('to-hide')) {
              product.classList.remove('to-hide');
            }
          }
        });
        this.slider.update();
        this.currentFilter = benefit;
      }
    }
    
    resetFilter() {
      this.removeClasses(this.products, 'to-hide');
      this.slider.update();
      $('.product-feed__collection').animate({ opacity: 1 }, 500);
    }

    removeClasses(elements, className) {
      elements.forEach(el => {
        el.classList.remove(className);
      });
    }
  }

  customElements.define('product-feed-filter', ProductFeedFilter);

  // Utils
  
  function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

  // Testimonials
  function autoHeightQuotes() {
    const quotes = document.querySelectorAll('.testimonials__list .testimonials__quote');

    if ( quotes.length ) {
      let maxHeight = 0;
      quotes.forEach(quote => {
        if ( quote.clientHeight > maxHeight ) {
          maxHeight = quote.clientHeight;
        }
      });

      quotes.forEach(quote => {
        quote.style.height = `${maxHeight}px`;
      });
    }
  }

function initTestimonials() {
  if (!document.querySelector('.testimonials__list .swiper-slide')) return;

  const slider = document.querySelector('.testimonials__slider');
let options = {
  slidesPerView: 'auto',
  spaceBetween: 0,
  loop: true,
  speed: 5000,
  autoplay: {
    delay: 0, // important for continuous scroll
    disableOnInteraction: false,
  },
  freeMode: {
    enabled: true,
    momentum: false,
  },
  freeModeMomentum: false,
  freeModeMomentumBounce: false,
  centeredSlides: false, // avoid snapping to center
}

  autoHeightQuotes();
  const swiperSlide = new Swiper(slider, options);
}

  function initMushroomLib() {
    if ( !document.querySelector('.mushroom-library .mushroom-library__slider') ) return;
    const slider = document.querySelector('.mushroom-library .mushroom-library__slider');
    const nextButton = document.querySelector('.mushroom-library .custom-button');
    const options = {
      slidesPerView: "auto",
      centeredSlides: false,
      spaceBetween: 20
    }

    if ( document.body.clientWidth > 767 ) {
      options.loop = true;
    }

    const mushroomSlider = new Swiper(slider, options);

    nextButton.addEventListener('click', function(){
      mushroomSlider.slideNext();
    });
  }

  function initInstagram() {
    // wrap first item
   const firstImage = $('.instafeed-new-layout-wrapper .instafeed-new-layout-item:first-child');
    firstImage.wrap("<div class='left-list'></div>");

    // wrap the rest of the item
    $('.left-list').nextAll().wrapAll('<div class="right-list"></div>');
  }

  function initSlidingHandles() {
    if ( !document.querySelector('.sliding-handle .swiper-slide') ) return;
    
    const slider = document.querySelector('.sliding-handle .swiper');
    const options = {
      slidesPerView: "auto",
      centeredSlides: true,
      spaceBetween: 100,
      speed: 8000,
      loop: true,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      }
    }
    const swiperSlide = new Swiper(slider, options);
  }

  // PRODUCT PAGE
  function productGallery() {
    if ( !document.querySelector('.product-gallery__item.swiper-slide') ) return;
    const productSlider = document.querySelector('.product-gallery__slider');
    const thumbnails = document.querySelector('.product-gallery__thumbnails');


    // Thumbnails
    const thumbnailSlider = new Swiper(thumbnails, {
      spaceBetween: 4,
      slidesPerView: 'auto',
      watchSlidesProgress: true
    })

    let options;
    
    if ( window.innerWidth < 990 ) {
      options = {
        slidesPerView: 1,
        centeredSlides: true,
        pagination: {
          el: '.swiper-pagination',
        }
      }
    } else {
      options = {
        direction: 'vertical',
        slidesPerView: 1,
        spaceBetween: 0,
        freeMode: true,
        mousewheel: {
          forceToAxis: true,
          sensitivity: 1,
          releaseOnEdges: true
        },
        thumbs: {
          swiper: thumbnailSlider
        }
      }
    }

    const slider = new Swiper(productSlider, options);
  }

  function initStickyATC() {
    if ( !document.querySelector('#shopify-section-add-to-cart-bar') ) return;

    
 
    const stickyBar = document.querySelector('#shopify-section-add-to-cart-bar');
    const endOfMain = document.querySelector('.product-inner');
    const mainOffset = endOfMain.offsetTop + endOfMain.clientHeight;

    let lastKnownScrollPosition = 0;
    let ticking = false;
    
    function showATC(scrollPos) {
      if ( scrollPos > mainOffset + 100  ) {
        stickyBar.classList.add('active');
      } else {
        stickyBar.classList.remove('active');
      }
    }
    
    document.addEventListener("scroll", (event) => {
      lastKnownScrollPosition = window.scrollY;
    
      if (!ticking) {
        window.requestAnimationFrame(() => {
          showATC(lastKnownScrollPosition);
          ticking = false;
        });
    
        ticking = true;
      }
    });

    
    const addButton = document.querySelector('[data-add-to-cart]');
    const stickyButton = document.querySelector('#shopify-section-add-to-cart-bar .product-bar__button');

    stickyButton.addEventListener('click', function(e){
      e.preventDefault();
      addButton.click();
      stickyButton.classList.add('is-loading');
    });
    
  }

  function initInsidePowder() {
    if ( !document.querySelector('.inside-powder__item') || !(window.innerWidth < 990) ) return;

    const slider = document.querySelector('.inside-powder__slider');
    const options = {
      slidesPerView: "auto",
      centeredSlides: true,
      spaceBetween: 20
    }

    
    if ( document.body.clientWidth > 767 ) {
      options.centeredSlides = false;
    }

    const powederSlider = new Swiper(slider, options);

  }

  function initRecommendationSlider() {
    if ( !document.querySelector('.product-recommendations__slider .swiper-slide') || !(window.innerWidth < 990) ) return;

    const slider = document.querySelector('.product-recommendations__slider');
    const options = {
      slidesPerView: "auto",
      centeredSlides: false,
      spaceBetween: 30
    }

    new Swiper(slider, options);
  }

  function addToCart() {
    const miniCartHeader = document.querySelector('#mini-cart');
    const miniCart = document.querySelector('mini-cart');

    miniCartHeader.addEventListener('click', function(e) {
      e.preventDefault();
      miniCart.open();
    });
  }

  function initPDP() {
    if ( !document.querySelector('.template-product') ) return;

    productGallery();
    initStickyATC();
    initInsidePowder();
    waitForElm('.product-recommendations__slider .swiper-slide').then((elm) => {
      initRecommendationSlider()
    });
    waitForElm('.product-info .sealsubs-target-element .sls-option-container:last-child .seal-col:nth-child(2n)').then((elm) => {
      if ( window.innerWidth < 990 ) {
        document.querySelector('.product-info .sealsubs-target-element .sls-option-container:last-child .seal-col:nth-child(2n) .sls-selling-plan-group-name').textContent = 'Subscribe & Save';
      }
    });
    waitForElm('.jdgm-row-media .jdgm-medals').then((elm) => {
      document.querySelector('.jdgm-row-media .jdgm-medals').closest('.jdgm-row-media').style.display = 'none'
    });
  }

  /**
   * Handles loading state for product buttons
   * @param {boolean} isLoading - Whether to add or remove loading state
   */
  function toggleLoadingState(isLoading = false) {
    const loadingButtons = document.querySelectorAll('.product-card__button.is-loading');
    loadingButtons.forEach(button => button.classList.remove('is-loading'));
  }

  /**
   * Adds a product to cart via AJAX and updates mini-cart
   * @param {string} variantId - The variant ID to add to cart
   */
  function cardAddToCart(variantId) {
    const miniCart = document.querySelector('mini-cart');
    const formData = {
      'items': [{
        'id': variantId,
        'quantity': 1
      }]
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      if (!response.ok) {
        toggleLoadingState();
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      toggleLoadingState();
      miniCart.updateView(true);
    })
    .catch((error) => {
      console.error('Error:', error);
      toggleLoadingState();
    });
  }

  /**
   * Initializes product card functionality for collections
   */
  function initCollectionCard() {
    if (!document.querySelector('.product-card__button')) return;

    if (window.innerWidth < 990) {
      const sizeAmountsTexts = document.querySelectorAll('.product-card__content .product-size-amount.has-product-variants');
      sizeAmountsTexts.forEach(text => {
        text.textContent = '';
      });
    }
    

    // Handle variant selection in dropdown
    const variantDropdowns = document.querySelectorAll('.product-card__button .product-card__variant-dropdown');
    variantDropdowns.forEach(dropdown => {
      dropdown.addEventListener('change', function(e) {
        e.preventDefault();
        
        const card = this.closest('.product-card__button');
        const variantId = this.value;
        const optionText = this.options[this.selectedIndex].textContent.trim();
        const button = card.querySelector('[data-add-to-cart]');
        const buttonValue = card.querySelector('.button__dropdown-value');
        const buttonWrapper = card.querySelector('.product-card__button-wrapper');
        const variantSelect = card.querySelector('.product-card__variant-select');
        const productCard = this.closest('.product-card');

        // Get the price container
        const priceContainer = productCard.querySelector('.price');
        
        // Fetch variant data
        fetch(`${window.Shopify.routes.root}variants/${variantId}.js`)
          .then(response => response.json())
          .then(variantData => {
            // Update price display
            if (priceContainer) {
              // Format prices
              const formattedPrice = formatMoney(variantData.price, window.theme?.moneyFormat || "${{amount}}");
              
              // Check if it's on sale
              if (variantData.compare_at_price && variantData.compare_at_price > variantData.price) {
                const formattedComparePrice = formatMoney(variantData.compare_at_price, window.theme?.moneyFormat || "${{amount}}");
                
                // Display sale price
                priceContainer.innerHTML = `
                  <div class="price__container">
                    <div class="price__sale">
                      <span>
                        <s class="price-item price-item--regular">
                          ${formattedComparePrice}
                        </s>
                      </span>
                      <span class="price-item price-item--sale price-item--last">
                        ${formattedPrice}
                      </span>
                    </div>
                  </div>
                `;
                
                // Add sale class to product card
                productCard.querySelector('.product-card__info')?.classList.add('product-card__info--sale');
                
                // Add sale tag if it doesn't exist
                if (!productCard.querySelector('.product-card__tag--sale')) {
                  const tagContainer = productCard.querySelector('.product-card__tag-labels');
                  if (tagContainer && !tagContainer.querySelector('.product-card__tag--sale')) {
                    tagContainer.innerHTML += '<div class="product-card__tag product-card__tag--sale">Sale</div>';
                  }
                }
              } else {
                // Display regular price
                priceContainer.innerHTML = `
                  <div class="price__container">
                    <div class="price__regular">
                      <span class="price-item price-item--regular">
                        ${formattedPrice}
                      </span>
                    </div>
                  </div>
                `;
                
                // Remove sale class from product card
                productCard.querySelector('.product-card__info')?.classList.remove('product-card__info--sale');
                
                // Remove sale tag if it exists
                const saleTag = productCard.querySelector('.product-card__tag--sale');
                if (saleTag) {
                  saleTag.remove();
                }
              }
            }
          })
          .catch(error => console.error('Error fetching variant data:', error));

        const sizeAmount = productCard.querySelector('.product-size-amount');
        if ( sizeAmount ) {
          sizeAmount.textContent = optionText;
        }
        
        // Update UI for selected variant
        button.dataset.variantId = variantId;
        buttonValue.textContent = optionText;
        buttonWrapper.classList.add('is-visible');
        variantSelect.classList.add('is-hidden');
      });
    });

    // Handle "back to selection" button
    const backSelectButtons = document.querySelectorAll('.product-card__button .button__dropdown-value');
    backSelectButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        const card = this.closest('.product-card__button');
        const buttonWrapper = this.closest('.product-card__button-wrapper');
        const variantSelect = card.querySelector('.product-card__variant-select');
        const dropdown = this.closest('.product-card__button').querySelector('.product-card__variant-dropdown');
        const productCard = this.closest('.product-card');
        
        // Return to variant selection
        buttonWrapper.classList.remove('is-visible');
        variantSelect.classList.remove('is-hidden');

        // Reset price display to original state
        const productId = dropdown.dataset.productId;
        if (productId) {
          fetch(`${window.Shopify.routes.root}products/${productId}?view=json`)
            .then(response => response.text())
            .then(html => {
              try {
                // Parse the JSON from the response
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = html;
                const jsonText = tempDiv.querySelector('script').textContent;
                const productData = JSON.parse(jsonText);
                
                // Reset price display
                const priceContainer = productCard.querySelector('.price');
                if (priceContainer && productData) {
                  // Reset price HTML to match the original product price
                  // Use the product-level price, not a specific variant
                  const onSale = productData.compare_at_price > productData.price;
                  
                  if (onSale) {
                    const formattedPrice = formatMoney(productData.price, window.theme?.moneyFormat || "${{amount}}");
                    const formattedComparePrice = formatMoney(productData.compare_at_price, window.theme?.moneyFormat || "${{amount}}");
                    
                    priceContainer.innerHTML = `
                      <div class="price__container">
                        <div class="price__sale">
                          <span>
                            <s class="price-item price-item--regular">
                              ${formattedComparePrice}
                            </s>
                          </span>
                          <span class="price-item price-item--sale price-item--last">
                            ${formattedPrice}
                          </span>
                        </div>
                      </div>
                    `;
                    
                    // Add sale class
                    productCard.querySelector('.product-card__info')?.classList.add('product-card__info--sale');
                    
                    // Add sale tag if not present
                    const tagContainer = productCard.querySelector('.product-card__tag-labels');
                    if (tagContainer && !tagContainer.querySelector('.product-card__tag--sale')) {
                      tagContainer.innerHTML += '<div class="product-card__tag product-card__tag--sale">Sale</div>';
                    }
                  } else {
                    const formattedPrice = formatMoney(productData.price, window.theme?.moneyFormat || "${{amount}}");
                    
                    priceContainer.innerHTML = `
                      <div class="price__container">
                        <div class="price__regular">
                          <span class="price-item price-item--regular">
                            ${formattedPrice}
                          </span>
                        </div>
                      </div>
                    `;
                    
                    // Remove sale class
                    productCard.querySelector('.product-card__info')?.classList.remove('product-card__info--sale');
                    
                    // Remove sale tag
                    const saleTag = productCard.querySelector('.product-card__tag--sale');
                    if (saleTag) {
                      saleTag.remove();
                    }
                  }
                }
              } catch (error) {
                console.error('Error parsing product JSON:', error);
              }
            })
            .catch(error => console.error('Error fetching product data:', error));
        }

        // Reset dropdown to placeholder value
        if (dropdown) {
          dropdown.selectedIndex = 0; // Reset to first option (placeholder)
          
          // Also reset the size amount display if it exists
          const sizeAmount = productCard.querySelector('.product-size-amount');
          if (sizeAmount) {
            sizeAmount.textContent = '';
          }
        }
      });
    });

    // Handle add to cart button click
    const addToCartButtons = document.querySelectorAll('.product-card__button [data-add-to-cart]');
    addToCartButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        const card = this.closest('.product-card__button');
        const variantId = this.dataset.variantId;
        
        card.classList.add('is-loading');
        cardAddToCart(variantId);
      });
    });
  }

  initTestimonials();
  initMushroomLib();
  initSlidingHandles();
  initPDP();
  initCollectionCard();

  if ( window.innerWidth > 990 ) {
     waitForElm('.instafeed-new-layout-wrapper .instafeed-new-layout-item').then((elm) => {
      initInstagram()
    });
  }
  addToCart();

  /**
   * Format money values based on shop's money format
   * @param {number} cents - Amount in cents
   * @param {string} format - Money format string
   * @return {string} Formatted money value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    let value = '';
    const match = formatString.match(placeholderRegex);
    
    if (!match) {
      return formatWithDelimiters(cents, 2);
    }
    
    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
    }
    
    return formatString.replace(placeholderRegex, value);
  }
})();
